__webpack_require__.p = "https://edubot.creo.hu/";